module.exports = __webpack_public_path__ + "static/media/TAN-background.249a4a4c.png";